import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LinkButton = ({ label, description, render }) => render({
    className: 'focus-visible:focus-ring-dep-thin text-dep-sm font-dep-mono rounded-dep-full border-dep-shade-900 text-dep-shade-800 hover:bg-dep-shade-900 hover:text-dep-shade-000 border-2 px-8 py-3 sm:py-5',
    tabIndex: 0,
    children: (_jsxs("span", { className: "flex items-center justify-center gap-3", children: [label, description && (_jsx("span", { className: "font-dep-display text-dep-xs self-end pb-1", children: description }))] })),
});
